import './styles/tokens.css';
import { Router } from './app/router';
import { CommentProvider } from './comments/CommentContext';
import { CommentOverlay } from './comments/CommentOverlay';
import { CommentIntro } from './comments/CommentIntro';
import { RoleProvider } from './shared/RoleContext';
import { AIRailScopeProvider } from './shared/AIRailScopeContext';
import { ChatProvider } from './shared/ChatContext';
import { SidebarStateProvider } from './shared/SidebarStateContext';

export default function V1App() {
  return (
    <CommentProvider version="v1">
      <RoleProvider>
        <SidebarStateProvider>
          <ChatProvider>
            <AIRailScopeProvider>
              <Router />
              <CommentOverlay />
              <CommentIntro />
            </AIRailScopeProvider>
          </ChatProvider>
        </SidebarStateProvider>
      </RoleProvider>
    </CommentProvider>
  );
}
